import React from "react"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js"
import { Bar } from "react-chartjs-2"

export interface StackedBarData {
  date: string
  value: number
}

interface BarChartProps {
  chartData: StackedBarData[]
  color?: string
  height?: string
  width?: string
}

// Chart.js 플러그인 등록
ChartJS.register(CategoryScale, LinearScale, BarElement)

const BarChart: React.FC<BarChartProps> = ({
  chartData,
  color = "#8575FA",
  height = "300px",
  width = "500px",
}) => {
  const labels = chartData.map((item) => item.date)
  const values = chartData.map((item) => item.value)

  const data = {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: color,
        borderRadius: 5,
      },
    ],
  }

  const options: import("chart.js").ChartOptions<"bar"> = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {},
      y: {
        beginAtZero: true,
      },
    },
    plugins: {
      legend: {
        display: false, // 레전드 제거
      },
      tooltip: {
        enabled: true, // 툴팁 활성화
        callbacks: {
          label: (context) =>
            `${Number(Number(context.raw).toFixed(0)).toLocaleString()}`, // 커스텀 툴팁 내용
        },
      },
    },
  }

  return (
    <div style={{ height, width }}>
      <Bar data={data} options={options} />
    </div>
  )
}

export default BarChart
